/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (morph envelope) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export const MORPH_FIELDS = {
	a: 'endpoint the morph starts from; ABSENT = anchor at the current value',
	b: 'endpoint the morph ends at',
	t: 'progress 0..1',
	f: 'interpolation function',
	fade: 'monotonic id, constant per fade, bumped on each new fade (re-latch key); ABSENT = 0',
}

export const MORPH_FUNCTIONS = ['slerp', 'nlerp', 'lerp']

/** The endpoint keys, in contract order: where the morph starts and where it lands. */
export const [MORPH_FROM, MORPH_TO] = Object.keys(MORPH_FIELDS)

/**
 * Is this value a morph envelope rather than a bare param value?
 *
 * ⚠️ AN OBJECT IS THE WHOLE TEST, because the wire type is `T | MorphEnvelope` — a scalar or an
 * envelope, with no third shape. Requiring particular keys once looked stricter, but it decided a
 * MALFORMED envelope was a BARE VALUE, which is the worse reading: `Math.round({t})` is `NaN` and
 * blanks the param, where routing it down the morph path surfaces the fault at the server's
 * validator. Completeness is the server model's job, and it is the only layer that can tell an
 * absent `a` (anchor at the current value — the common case) from a dropped one.
 */
export function isMorphEnvelope(value) {
	return !!value && typeof value === 'object' && !Array.isArray(value)
}
